// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "spa-assets/on-demand/ml-shared-ml-power-footer-module-styles") return "spa-assets/on-demand/ml-shared-ml-power-footer-module-styles-fadafbdafb2ebaa016da.m.css";
	// return url for filenames based on template
	return undefined;
};